import React, { useState } from "react";
import { toast } from "sonner";
import { Share2, Link2, MessageSquare, Facebook, Twitter, Phone } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const stop = (e) => { e.preventDefault(); e.stopPropagation(); };

export const TripShareButton = ({ ev, className = "" }) => {
  const [open, setOpen] = useState(false);
  const url = `${window.location.origin}/interest/${ev.slug}`;
  const text = `${ev.name} — register your interest with CBR Nation:`;
  const enc = encodeURIComponent;
  const links = [
    { id: "text", label: "Text message", icon: MessageSquare, href: `sms:?&body=${enc(`${text} ${url}`)}` },
    { id: "whatsapp", label: "WhatsApp", icon: Phone, href: `https://wa.me/?text=${enc(`${text} ${url}`)}` },
    { id: "facebook", label: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { id: "x", label: "X / Twitter", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(url)}` },
  ];

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copied — paste it anywhere"); }
    catch { toast.error("Couldn't copy the link"); }
    setOpen(false);
  };

  const onTrigger = async (e) => {
    stop(e);
    if (navigator.share && window.matchMedia("(pointer: coarse)").matches) {
      try { await navigator.share({ title: ev.name, text, url }); } catch { /* cancelled */ }
      return;
    }
    setOpen((o) => !o);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`trip-share-${ev.slug}`} onClick={onTrigger} aria-label={`Share ${ev.name}`}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-[10px] font-bold uppercase tracking-wider rounded-full bg-white/90 text-[#0A192F] hover:bg-white transition-colors ${className}`}>
          <Share2 className="w-3 h-3" /> Share
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-52 p-1.5" onClick={stop} data-testid={`trip-share-menu-${ev.slug}`}>
        <button type="button" data-testid={`trip-share-copy-${ev.slug}`} onClick={(e) => { stop(e); copy(); }}
          className="w-full flex items-center gap-2 px-3 py-2 text-sm rounded-sm hover:bg-slate-100">
          <Link2 className="w-4 h-4 text-[#E63946]" /> Copy link
        </button>
        {links.map((l) => (
          <a key={l.id} href={l.href} target="_blank" rel="noreferrer" data-testid={`trip-share-${l.id}-${ev.slug}`}
            onClick={(e) => { e.stopPropagation(); setOpen(false); }}
            className="flex items-center gap-2 px-3 py-2 text-sm rounded-sm hover:bg-slate-100">
            <l.icon className="w-4 h-4 text-[#E63946]" /> {l.label}
          </a>
        ))}
      </PopoverContent>
    </Popover>
  );
};
